import { Module06, Module06Props } from 'components/gruenland/organisms/mod06Editoriale2/Module06';
import { TasticProps } from '../../types';

const Editoriale2Tastic = ({ data }: TasticProps<Module06Props>) => {
  return <Module06 {...data} />;
};
export default Editoriale2Tastic;
